export const excuteScriptCode = (inputData: any, filterCode: any, errorCb?: (error?: any) => void): any => {
    // 如果输入的是空数据，直接返回空数组
    if (!inputData) {
        return [];
    }

    const strWrapper = `const data = arguments[0];`;
    const strFunc = strWrapper + filterCode;
    let returnValue: any[] | string = [];
    
    // 封装函数的活动对象，函数上下文
    // Object、Array、Date、Math、parseInt、parseFloat、String、RegExp、Boolean、JSON
    const context = {
        Object: Object,
        Array: Array,
        Date: Date,
        Math: Math,
        String: String,
        RegExp: RegExp,
        Boolean: Boolean,
        JSON: JSON,
        parseInt: parseInt,
        parseFloat: parseFloat,
    }

    try {
        returnValue = new Function(strFunc).apply(context, [inputData]);
    } catch (error) {
        // 异常处理
        returnValue = '解析失败';
        console.log('报错了')
        errorCb && errorCb(error);
    }
    return returnValue;
}